<div>
  <div class="filter-header">
    <span class="heading-text"> Filters </span>
    <span class="clear-filter primary-color pointer-cursor" *ngIf="hasFilter"
          (click)="clearFilter()"> Clear Filters </span>
  </div>
  <div class="container-fluid filters" *ngIf="refreshFilters">
    <div class="row">
      <div style="width: 190px;" *ngIf="this.indexType === 'emix' && false">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Master ID</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('masterID')}">
                {{masterIDCount > -1 ? masterIDCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <input type="text" class="short typeahead" (keyup)="searchByMasterID($event)" placeholder="Enter text" [(ngModel)]="masterID">
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType === 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Index Name</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('indexName')}">
                {{indexNameCount > -1 ? indexNameCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <div class="controlContainer">
            <input type="text" class="short typeahead" (keyup)="searchByIndexName()" placeholder="Enter text" [(ngModel)]="indexName">
          </div>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Region</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('region')}">
                {{regionResultCount > -1 ? regionResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="region" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="region.options.length" (itemSelectedEvent)="storeFilters($event, 'region')" (filterAppliedEvent)="applyFilter($event, 'region')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 270px;">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Index Family</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('indexFamily')}">
                {{familiesResultCount > -1 ? familiesResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [enableSearch]="true" [data]="families" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="2"
                             [maxItemsToChoose]="families.options.length" (itemSelectedEvent)="storeFilters($event, 'indexFamily')" (filterAppliedEvent)="applyFilter($event, 'indexFamily')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Index Currency</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('indexCurrency')}">
                {{currencyResultCount > -1 ? currencyResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [enableSearch]="true" [data]="currency" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="5"
                             [maxItemsToChoose]="currency.options.length" (itemSelectedEvent)="storeFilters($event, 'indexCurrency')" (filterAppliedEvent)="applyFilter($event, 'indexCurrency')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">FX Version</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('fxVersion')}">
                {{fxVersionResultCount > -1 ? fxVersionResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="fxVersion" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="fxVersion.options.length" (itemSelectedEvent)="storeFilters($event, 'fxVersion')" (filterAppliedEvent)="applyFilter($event, 'fxVersion')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Investment Type</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('investmentType')}">
                {{investmentTypeResultCount > -1 ? investmentTypeResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="investmentType" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="investmentType.options.length" [disabled]="indexType !== 'all'" (itemSelectedEvent)="storeFilters($event, 'investmentType')" (filterAppliedEvent)="applyFilter($event, 'investmentType')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Sector</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('sector')}">
                {{sectorResultCount > -1 ? sectorResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="sector" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="sector.options.length" (itemSelectedEvent)="storeFilters($event, 'sector')" (filterAppliedEvent)="applyFilter($event, 'sector')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Sub-sector</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('subSector')}">
                {{subSectorResultCount > -1 ? subSectorResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="subSector" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="subSector.options.length" (itemSelectedEvent)="storeFilters($event, 'subSector')" (filterAppliedEvent)="applyFilter($event, 'subSector')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Rating</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('rating')}">
                {{ratingResultCount > -1 ? ratingResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [enableSearch]="true" [data]="rating" [hasFilter]="hasFilter" dropdownType="multi"
                             [maxItemsToChoose]="rating.options.length" (itemSelectedEvent)="storeFilters($event, 'rating')" (filterAppliedEvent)="applyFilter($event, 'rating')"></app-ihsm-dropdown-lib>
        </div>
      </div>
      <div style="width: 190px;" *ngIf="this.indexType !== 'emix'">
        <div class="labelWrapper">
          <span class="ihsm-dropdown-label">Maturity</span>
          <span class="ihsm-dropdown-label count-label"
                [ngClass]="{'count-label-active': filter.hasOwnProperty('maturity')}">
                {{maturityResultCount > -1 ? maturityResultCount : 'NA'}}</span>
        </div>
        <div class="controlContainer">
          <app-ihsm-dropdown-lib class="multi-dropdown" [data]="maturity" [hasFilter]="hasFilter" dropdownType="multi" [maxLabelsDisplay]="3"
                             [maxItemsToChoose]="maturity.options.length" (itemSelectedEvent)="storeFilters($event, 'maturity')" (filterAppliedEvent)="applyFilter($event, 'maturity')"></app-ihsm-dropdown-lib>
        </div>
      </div>
    </div>
  </div>
</div>
